import { RemoteConstants } from '../../data/remote/RemoteConstants';

/* eslint-disable no-unused-vars */
export const fetchClientDebt = async (token, params) => {
    try {

        const remesaCompleteParam = params.find(p => p.name === 'remesa_complete');
        const isRemesaComplete = remesaCompleteParam?.value === true || remesaCompleteParam?.value === 'true';

        const isRemesaParam = params.find(p => p.name === 'isRemesa');
        const isRemesa = isRemesaParam?.value === true || isRemesaParam?.value === 'true';

        let peticion;

        // REMESA COMPLETA - Segundo paso del formulario
        if (isRemesaComplete) {
            console.log('Entra en remesa completo')
            console.log('Params:', params);
            peticion = await fetch(`${RemoteConstants.BASE_URL}engine/send/request`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    token: token,
                    sku: params.find(p => p.name === 'sku')?.value || '',
                    destination: params.find(p => p.name === 'destination')?.value || '',
                    amount: params.find(p => p.name === 'amount')?.value || '',
                    messageType: params.find(p => p.name === 'messageType')?.value || '1',
                    requestFrom: params.find(p => p.name === 'requestFrom')?.value || 'web',
                    attrs: {
                        OP_ID: params.find(p => p.name === 'op_id')?.value || '',
                        identificationNumber: params.find(p => p.name === 'identificationNumber')?.value || '',
                        bankCode: params.find(p => p.name === 'bankCode')?.value || ''
                    }
                })
            })
                .then(resp => resp.json())
                .then(data => {
                    if (data.code === 'OK') {
                        return data.data;
                    } else {
                        throw new Error(data.userMessage);
                    }
                });
        }
        // REMESA INICIAL - Primer paso (obtener cálculo)
        else if (isRemesa) {
            console.log('Entra en remesa inicial')
            console.log('Params:', params);
            peticion = await fetch(`${RemoteConstants.BASE_URL}engine/send/request`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    token: token,
                    sku: params.find(p => p.name === 'sku')?.value || '',
                    destination: params.find(p => p.name === 'destination')?.value || '',
                    amount: params.find(p => p.name === 'amount')?.value || '',
                    messageType: 10,
                    requestFrom: 'web',
                    attrs: {}
                })
            })
                .then(resp => resp.json())
                .then(data => {
                    if (data.code === 'OK') {
                        return data.data;
                    } else {
                        throw new Error(data.userMessage);
                    }
                });
        }
        // DEUDA
        else {
            console.log('Entra en deuda')
            const queryParams = new URLSearchParams({
                token: token,
                requestFrom: 'web'
            });

            params.forEach(param => {
                if (param.name === 'sku') {
                    queryParams.append('sku', param.value);
                } else if (param.name === 'destination' || param.name === 'dni') {
                    queryParams.append('destination', param.value);
                }
            });

            peticion = await fetch(`${RemoteConstants.BASE_URL}debt/send/request?${queryParams.toString()}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
                .then(resp => resp.json())
                .then(data => {
                    if (data.code === 'OK') {
                        return data.data;
                    } else {
                        throw new Error(data.userMessage);
                    }
                });
        }

        return peticion;
    } catch (error) {
        throw error.message;
    }
}

// Función para procesar el pago/venta con el endpoint de remesas
export const fetchProcessPayment = async (token, params, opId) => {
    console.log('Entra en pago')
    console.log('Params', params)
    try {
        const response = await fetch(`${RemoteConstants.BASE_URL}engine/send/request`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token: token,
                sku: params.find(p => p.name === 'sku')?.value || '',
                destination: params.find(p => p.name === 'destination')?.value || '',
                amount: params.find(p => p.name === 'amount')?.value || '',
                messageType: 1,
                requestFrom: 'web',
                attrs: {
                    OP_ID: opId,
                    identificationNumber: params.find(p => p.name === 'identificationNumber')?.value || '',
                    bankCode: params.find(p => p.name === 'bankCode')?.value || ''
                }
            })
        })
            .then(resp => resp.json())
            .then(data => {
                if (data.code === 'OK') {
                    return data.data;
                } else {
                    throw new Error(data.userMessage);
                }
            });

        return response;
    } catch (error) {
        throw error.message;
    }
}